export default function OrdersList({ orders }) {
	return (
		<div className="dashboard-card">
			<div className="card-head">
				<div>
					<p className="panel-overline">Commandes</p>
					<h3>Dernières commandes</h3>
				</div>
			</div>
			<ul className="order-list">
				{orders.map((order) => (
					<li key={order.id} className="order-row">
						<div>
							<strong>{order.id}</strong>
							<p className="muted">{order.customer}</p>
						</div>
						<div className="order-meta">
							<span className="pill muted">{order.status}</span>
							<span className="order-amount">{order.amount}</span>
							<span className="order-eta">{order.eta}</span>
						</div>
					</li>
				))}
			</ul>
		</div>
	);
}
